import { Grid, Paper, Typography, Box } from "@mui/material";
import CalcPercenteProgressBar from "../../../functions/disponibilita/calcPercenteProgressBar";
import useMobileDetection from "../../../Hooks/useMobileDetection";
import {
  ProgressBarDisponibilitaLinear,
  ProgressBarDisponibilitaCircular,
} from "./ProgressBarDisponibilita";
import { useTranslation } from "react-i18next";

export default function ViewRowDisponibilita({
  element,
  returnIdElementClicked,
  lengthArrElementPath,
  percentStatusConfiguration,
}) {
  const { t } = useTranslation();

  const {
    denominazione,
    sigla,
    totPostazioniOccupate,
    totPostazioniDisponibili,
    totPostazioni,
  } = element;

  function insertElement(el) {
    if (lengthArrElementPath < 3 && totPostazioni > 0)
      returnIdElementClicked(el);
  }

  let { valueProgressBar, colorProgressbar } = CalcPercenteProgressBar(
    percentStatusConfiguration,
    totPostazioniOccupate,
    totPostazioniDisponibili
  );

  const isMobile = useMobileDetection();

  return (
    <>
      <Paper
        className="rowDisponibilita box-shadow-light"
        onClick={() => {
          insertElement(element);
        }}
        sx={
          lengthArrElementPath < 3 && totPostazioni > 0
            ? { cursor: "pointer" }
            : {}
        }
      >
        <Grid container alignItems="stretch">

          <Grid item xs={2} sm={2} md={2} lg={1}>
            <Paper className="cardDisponibilitaSigla flex-center-center no-box-shadow" sx={{ width: "100%" }}>
              <Typography sx={{ color: "#3e6bb4" }}>
                <b>{sigla.toUpperCase()}</b>
              </Typography>
            </Paper>
          </Grid>

          <Grid item xs={8} sm={8} md={8} lg={9} sx={{ p: 1 }}>
            <Typography className="textDisponibilta font-w500">
              {denominazione}
            </Typography>
            <Typography className="textDisponibilta">
              {totPostazioni > 0 ? (
                <i>{totPostazioniOccupate}/{totPostazioniDisponibili}</i>
              ) : (
                <i>{t("no_items")}</i>
              )}
            </Typography>
          </Grid>

          <Grid
            item
            xs={2}
            sm={2}
            md={2}
            lg={2}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            {totPostazioni > 0 &&
              (isMobile ? (
                <ProgressBarDisponibilitaCircular mr={2}
                  colorProgressBar={colorProgressbar}
                  value={valueProgressBar}
                />
              ) : (
                <Box sx={{ width: "100%" }}>
                  <ProgressBarDisponibilitaLinear
                    colorProgressBar={colorProgressbar}
                    value={valueProgressBar}
                  />
                </Box>
              ))}
          </Grid>
        </Grid>
      </Paper>
    </>
  );
}
